import store from "@/store";
export default {
  inserted(el, binding) { // 被绑定元素插入父节点时调用
    const { value } = binding;
    if (value) {
      const strVal = value.toString();
      if (!store.getters.permissionList.includes(strVal)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`need roles! Like v-permission="123"`);
    }
  }
};
